import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  Col,
  Collapse,
  Container,
  Form,
  FormGroup,
  Input,
  Jumbotron,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row } from 'reactstrap';

class DTCAutoPay extends Component {
  state = {
    rSelected: [],
    modal: false,
    bankInfoOpen: false,
    canProceed: false
  }

  handleRadioBtnClick = (rSelected) => {
    this.setState({
      rSelected,
      canProceed: true
    });

    if (rSelected === false) {
      this.setState({ bankInfoOpen: false });
    } else if (rSelected === true) {
      this.setState({ bankInfoOpen: true });
    }
  }

  handleModal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }

  onCheckboxBtnClick = (selected) => {
    const index = this.state.cSelected.indexOf(selected);
    if (index < 0) {
      this.state.cSelected.push(selected);
    } else {
      this.state.cSelected.splice(index, 1);
    }
    this.setState({ cSelected: [...this.state.cSelected] });
  }

  render() {
    const { modal, bankInfoOpen, canProceed } = this.state;

    return (
      <div className="page-autopay">
        <Jumbotron>
          <Container>
            <Row>
              <Col xs="auto" lg={{ size: 'auto', offset: 2 }}>
                <Card color="primary" className="mb-0 pull-30">
                  <CardBody>
                    <h1 className="mb-1 mr-2 text-light" style={{ fontWeight: 700 }}><i>TREAT YOURSELF!</i></h1>
                    <p className="mb-0 text-light">Enroll in Optional ACH Auto-Pay and you<br/>
                    could earn a <strong><u>$25 Statement Credit</u>*</strong></p>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </Jumbotron>
        <Container>
          <Row className="justify-content-center mb-3">
            <Col lg={8}>
              <Row>
                <Col className="mb-2 mb-md-4 mt-1 mt-md-3">
                  <h1 className="mb-2">Auto-Pay Election</h1>
                  <p>Enroll in optional ACH Auto-Pay for free and never miss a payment again. <br className="d-none d-md-block" />
                  Plus enroll in optional Auto-Pay and you could earn a <strong>$25 Statement Credit</strong>.&dagger; <br className="d-none d-md-block" />
                  <span className="text-link" onClick={this.handleModal}>View Details</span></p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Card className="border-primary bg-light pull-30">
                    <CardBody>
                      <Row>
                        <Col xs={12}>
                          <ButtonGroup className="w-100 mb-2">
                            <Button color="primary" onClick={() => this.handleRadioBtnClick(true)} active={this.state.rSelected === true}>Enroll in Auto-Pay</Button>
                            <Button color="primary" onClick={() => this.handleRadioBtnClick(false)} active={this.state.rSelected === false}>Decline Auto-Pay</Button>
                          </ButtonGroup>
                        </Col>
                        <Col md={6} className="text-center mb-2 mb-md-0">
                          <small>YES &nbsp;–&nbsp; I want to enroll in ACH Auto-Pay and become eligible to receive a $25 statement credit! &dagger; <span className="text-link" onClick={this.handleModal}>View Details</span></small>
                        </Col>
                        <Col md={6} className="text-center">
                          <small>NO &nbsp;–&nbsp; I do not want to Enroll in ACH Auto-Pay at this time. All debit card payments, including debit card Auto-Pay, may incur additional fees.</small>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Collapse isOpen={bankInfoOpen}>
                <Row>
                  <Col>
                    <Card className="border-light pull-30 animated fadeIn delay-200ms">
                      <CardHeader>
                        <h4 className="mb-0">Checking Account Information <span>(Optional)</span></h4>
                      </CardHeader>
                      <CardBody>
                        <Form>
                          <Row>
                            <Col lg={6}>
                              <FormGroup className="mb-md-2">
                                <Label for="accountHolderFirstName">Account Holder First Name</Label>
                                <Input type="text" name="account-holder-firstname" id="accountHolderFirstName" />
                              </FormGroup>
                            </Col>
                            <Col lg={6}>
                              <FormGroup className="mb-md-2">
                                <Label for="accountHolderLastName">Account Holder Last Name</Label>
                                <Input type="text" name="account-holder-lastname" id="accountHolderLastName" />
                              </FormGroup>
                            </Col>
                            <Col lg={6}>
                              <FormGroup className="mb-md-0">
                                <Label for="routingNumber">Routing Number</Label>
                                <Input type="text" name="routing-number" id="routingNumber" />
                              </FormGroup>
                            </Col>
                            <Col lg={6}>
                              <FormGroup className="mb-0">
                                <Label for="accountNumber">Account Number</Label>
                                <Input type="text" name="account-number" id="accountNumber" />
                              </FormGroup>
                            </Col>
                            <Col>
                              <img
                                src="/images/check-numbers.jpg"
                                alt="Example Check"
                                width="100%"
                                className="mt-1"
                                style={{ marginLeft: '-30px', marginRight: '-30px', marginBottom: '-23px', width: 'calc(100% + 60px)' }}
                              />
                            </Col>
                          </Row>
                        </Form>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Collapse>
              <Row>
                <Col className="mb-1">
                  <p><strong>Please Note:</strong> Enrolling in ACH Auto-Pay is optional. The Bank's credit decision is not dependent on whether you enroll in ACH Auto-Pay. You can change your method of payment at any time.</p>
                </Col>
              </Row>
              <div className="text-center">
                <Button tag={Link} to="/dtc/sign" color="primary" size="lg" className="mb-2 mt-1" disabled={ !canProceed }>Save &amp; Continue</Button>
              </div>
            </Col>
          </Row>
        </Container>

        <Modal isOpen={modal} toggle={this.handleModal} size="lg">
          <ModalHeader toggle={this.handleModal}>Promotion Details</ModalHeader>
          <ModalBody>
            &dagger; To qualify for the $25 Statement Credit (“Statement Credit”) Promotion (“Promotion”), you must enroll in optional ACH Auto-Pay (“Auto-Pay”) at the same time that you execute your loan agreement with Cross River Bank and successfully make your first 3 scheduled monthly payments using Auto-Pay. Each monthly payment must post to your loan account prior to the expiration of any applicable grace period. You understand that you are not required to enroll in Auto-Pay unless you want to take advantage of this promotional offer, and your willingness to enroll in Auto-Pay will not affect Cross River Bank’s credit decision regarding your loan application. Limit one (1) Statement Credit per loan. Promotion cannot be transferred or assigned. After making your first 3 scheduled monthly payments using Auto-Pay payment, the Statement Credit will be applied to the next scheduled payment. The Statement Credit will be applied to the account pursuant to the ‘Application of Payments’ section in your Loan Agreement. Enrollment for the Statement Credit/Promotion must be made before December 31, 2018. This Promotion is subject to change or discontinuation without notice.
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export default DTCAutoPay;
